export enum TaskStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  FAILED = "FAILED",
  FAILED_WITH_TERMINAL_ERROR = "FAILED_WITH_TERMINAL_ERROR",

  SCHEDULED = "SCHEDULED",
  CANCELED = "CANCELED",
  COMPLETED_WITH_ERRORS = "COMPLETED_WITH_ERRORS",
  TIMED_OUT = "TIMED_OUT",
  SKIPPED = "SKIPPED",

  PENDING = "PENDING",
}
